import React from 'react';
import './ReasonsSection.css';
import { Trans, useTranslation } from 'react-i18next';

interface Reason {
  text: string;
}

const ReasonsSection: React.FC = () => {
  // 1. Hook vacío
  const { t } = useTranslation();

  // 2. Obtenemos la lista usando el namespace 'reasons'
  const reasonsJson = t('reasons:list', { returnObjects: true }) as Reason[] | undefined;

  // 3. Fallback seguro por si no ha cargado el JSON
  const reasonsData: Reason[] = Array.isArray(reasonsJson) ? reasonsJson : [];

  return (
    <section className="reasons-section">
      <div className="reasons-overlay"></div>
      
      <div className="reasons-content">
        <div className="reasons-title">
          <p className="title">
            <Trans 
              i18nKey="reasons:subtitle" 
              components={[<span className="big-number" />]} 
            />
          </p>
          <h1>
            {/* Texto: PARA HOSPEDARTE... */}
            <Trans i18nKey="reasons:title" />
          </h1>
        </div>
        
        <div className="reasons-grid">
          {reasonsData.map((reason, index) => (
            <div key={index} className="reason-pill">
              {reason.text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReasonsSection;